(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('PaymentSlipsController', PaymentSlipsController);

    /** @ngInject */
    function PaymentSlipsController($rootScope, $scope, AuthenticationService, PaymentService, HelperService, ROUTES, DATA_EVENTS) {
        const vm = this;
        let forcePaginationReset = false;

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPaymentSlips(start, number, tableState);
        }

        vm.getPaymentSlipStatusClass = paymentSlip => {
            if (paymentSlip.PaymentConfirmation && paymentSlip.PaymentConfirmation.Id)
                return 'paid';

            if (!paymentSlip.PaymentRemittance || !paymentSlip.PaymentRemittance.RegistrationDate)
                return '';

            var diff = moment().diff(paymentSlip.PaymentRemittance.RegistrationDate, 'days');

            if (diff <= 15)
                return 'new';

            return 'old';
        }

        vm.getPaymentSlipStatusText = paymentSlip => {
            if (paymentSlip.PaymentConfirmation && paymentSlip.PaymentConfirmation.Id)
                return 'PAGO';

            if (!paymentSlip.PaymentRemittance || !paymentSlip.PaymentRemittance.RegistrationDate)
                return 'EM ABERTO';

            var diff = moment().diff(paymentSlip.PaymentRemittance.RegistrationDate, 'days');

            if (diff <= 15)
                return 'NOVO';

            return 'EM ABERTO';
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            vm.tableCallServer();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getPaymentSlips(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PaymentService
                .getByParameters(parameters)
                .then(success => {
                    vm.paymentSlips = success.Slips;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.units = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'PaymentDueDate',
                OrderDescending: true,
                UnitId: AuthenticationService.getSelectedUnit().Id,
                StartDueDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
                ListDeleted: false
            }

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            return params;
        }

        function init() {
            vm.isLoading = true;
            vm.CENTRAL_CONTAS = ROUTES.CENTRAL_CONTAS;
        }
    }
}());